var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2904 15.8242L8.80377 13.3375H19.9937C20.4835 13.3375 20.898 12.9608 20.898 12.4333V11.529C20.898 11.0392 20.4835 10.6248 19.9937 10.6248H8.80377L11.2904 8.17582C11.6295 7.83673 11.6295 7.23391 11.2904 6.89482L10.6499 6.25432C10.3108 5.91523 9.70801 5.91523 9.36892 6.25432L4.28257 11.3783C3.90581 11.7174 3.90581 12.2826 4.28257 12.6217L9.36892 17.7457C9.70801 18.0848 10.3108 18.0848 10.6499 17.7457L11.2904 17.1052C11.6295 16.7661 11.6295 16.1633 11.2904 15.8242Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.fe92b4b713838e0482c17e5209a979a3.svg";
export { ForwardRef as ReactComponent };